module.exports = __webpack_public_path__ + "media/images/emblems/Pohlern-coat_of_arms-a14898f8804927b633e54947376b62f8.svg";